import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/web.timers.js";
import { mapState } from 'vuex';
import { walletConnect, checkMetamask, okxwalletConnect, checkOkxwallet, switchChain, walletConnectDisAble, logOut, walletConnectCoinbase } from '@/utils/connect.js';
import { localStorage } from '@/store/storage';
import { getConnectChainListFilter } from '@/utils/chainInfo';
import { ArrowDown } from '@element-plus/icons-vue';
export default {
  props: {
    isQuery: {
      type: Boolean,
      "default": false
    }
  },
  components: {
    ArrowDown: ArrowDown
  },
  data: function data() {
    return {
      isSelectNet: false,
      showConnect: false,
      //连接钱包弹框是否显示
      selectdChainId: null,
      chainListMore: false,
      walletSelectedMore: false
    };
  },
  computed: _objectSpread({
    isMobile: function isMobile() {
      return this.$store.state.isMobile;
    },
    //是否安装metamask
    isMetamask: function isMetamask() {
      return checkMetamask();
    },
    //是否安装OKX Wallet
    isOkxWallet: function isOkxWallet() {
      return checkOkxwallet();
    },
    chainList: function chainList(chainListMore, isMobile) {
      return function (chainListMore, isMobile) {
        var arr = getConnectChainListFilter();
        return arr;
      };
    },
    walletList: function walletList(walletSelectedMore, isMobile) {
      return function (walletSelectedMore, isMobile) {
        var _this = this;
        var arr = [{
          icon: require('@/assets/image/connect/icon_metamask.png'),
          title: 'MetaMask',
          key: 'MetaMask'
        }, {
          icon: require('@/assets/image/connect/icon_walletconnect.png'),
          title: 'WalletConnect',
          key: 'WalletConnect'
        }, {
          icon: require('@/assets/image/connect/icon_coinbase.png'),
          title: 'Coinbase Wallet',
          key: 'Coinbase'
        }, {
          icon: require('@/assets/image/connect/icon_okx.png'),
          title: 'OKX',
          key: 'OKX'
        }, {
          icon: require('@/assets/image/connect/icon_trustWallet.png'),
          title: 'Trust Wallet',
          key: 'TrustWallet'
        }, {
          icon: require('@/assets/image/connect/icon_bitGet.png'),
          title: 'Bitget Wallet',
          key: 'Bitget'
        }, {
          icon: require('@/assets/image/connect/icon_tokenpocket.png'),
          title: 'TokenPocket',
          key: 'TokenPocket'
        }, {
          icon: require('@/assets/image/connect/icon_gate_wallet.png'),
          title: 'Gate Wallet',
          key: 'Gate'
        }, {
          icon: require('@/assets/image/connect/Nabox.svg'),
          title: 'Nabox Wallet',
          key: 'Nabox'
        }, {
          icon: require('@/assets/image/connect/icon_burrito_wallet.png'),
          title: 'Burrito Wallet',
          key: 'Burrito'
        }, {
          icon: require('@/assets/image/connect/icon_Rabby_Wallet.png'),
          title: 'Rabby Wallet',
          key: 'Rabby'
        }];
        if (this.isMobile) {
          arr.push({
            icon: require('@/assets/image/connect/icon_Foxwallet.svg'),
            title: 'Fox Wallet',
            key: 'Fox'
          });
        }
        if (this.getWaletsList) {
          arr = arr.filter(function (item) {
            var status = true;
            if (_this.getWaletsList[item.title]) {
              if (_this.getWaletsList[item.title].showFlag == 1) {} else {
                status = false;
              }
            } else {
              status = false;
            }
            return status;
          });
          arr = arr.map(function (item) {
            if (_this.getWaletsList[item.title]) {
              item.sort = _this.getWaletsList[item.title].sort;
            }
            return item;
          });
          arr = arr.sort(function (a, b) {
            return Number(b.sort) - Number(a.sort);
          });
        }
        return arr;
      };
    }
  }, mapState(['isSupportChainid', 'isSupportConnect', 'getWaletsList', 'setChainsList'])),
  watch: {
    showConnect: {
      handler: function handler(to, from) {
        if (to) {
          this.chainListMore = false;
          this.walletSelectedMore = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted: function mounted() {},
  methods: {
    showMore: function showMore() {
      this.chainListMore = true;
    },
    showWalletSelectedMore: function showWalletSelectedMore() {
      this.walletSelectedMore = true;
    },
    callBackRequest: function callBackRequest() {
      if (this.$store.state.showConnectIsQuery) {
        this.$emit('requestConnect');
      }
    },
    supportChainid: function supportChainid(item) {
      var status = true;
      if (this.isSupportChainid.length > 0) {
        if (this.isSupportChainid.indexOf("".concat(item.chainId)) == -1) {
          status = false;
        }
      }
      return status;
    },
    handleChainSelected: function handleChainSelected(item) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(item.chainId == _this2.$store.state.chainid)) {
                _context.next = 4;
                break;
              }
              _this2.selectdChainId = item.chainId;
              _this2.isSelectNet = false;
              return _context.abrupt("return");
            case 4:
              if (!(_this2.$store.state.connectChain || _this2.isSupportConnect)) {
                _context.next = 12;
                break;
              }
              _this2.showConnect = false;
              _context.next = 8;
              return switchChain(item.chainId);
            case 8:
              res = _context.sent;
              if (_this2.isSupportConnect) {
                _this2.$store.commit('setSignConnectCallBack', true);
              }
              setTimeout(function () {
                _this2.$store.commit('setIsSupportChainid', []);
                _this2.$store.commit('setIsSupportConnect', false);
              }, 500);
              return _context.abrupt("return");
            case 12:
              _this2.selectdChainId = item.chainId;
              _this2.isSelectNet = false;
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleBack: function handleBack() {
      this.isSelectNet = true;
    },
    handleWalletSelected: function handleWalletSelected(item) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.connect(item.key);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    handleClose: function handleClose() {
      var _this4 = this;
      this.$store.commit('setShowConnect', false);
      this.showConnect = false;
      setTimeout(function () {
        _this4.$store.commit('setIsSupportChainid', []);
        _this4.$store.commit('setIsSupportConnect', false);
      }, 500);
    },
    getProvider: function getProvider() {
      var provider = window.foxwallet && window.foxwallet.aleo;
      if (!provider) {
        window.open('https://foxwallet.com/download');
        return false;
      }
      return provider;
    },
    /**
     * 连接电子钱包
     */
    connect: function connect(type) {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var href, scheme, action, url, _url, _href, _url2;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              // if (!this.$store.state.suid && this.$store.state.suid != null && type == localStorage.getItem('walletType')) {
              //   console.log('==$initWallet==')
              //   this.$initWallet().then(() => {
              //     this.connect(type)
              //   }).catch(error => {
              //   });
              //   return
              // }
              /**
               * MetaMask连接
               */
              localStorage.removeItem('walletConnectCoinbase');
              _this5.showConnect = false;
              setTimeout(function () {
                _this5.$store.commit('setIsSupportChainid', []);
                _this5.$store.commit('setIsSupportConnect', false);
              }, 500);
              if (type == 'MetaMask' || type == 'TokenPocket' || type == 'TrustWallet' || type == 'Bitget' || type == 'Nabox' || type == 'Rabby' || type == 'Gate' || type == 'Fox') {
                if (_this5.isMetamask) {
                  if (localStorage.getItem('walletconnect')) {
                    logOut();
                    walletConnectDisAble();
                  }
                  localStorage.setItem('wallectTypeConnect', type);
                  okxwalletConnect(window.ethereum, 'metamask', _this5.selectdChainId, 1).then(function (res) {
                    console.log('==okxwalletConnect.ethereum==');
                    localStorage.setItem('walletType', type);
                    if (localStorage.getItem('wallectTypeConnect')) {
                      localStorage.removeItem('wallectTypeConnect');
                    }
                    _this5.$store.commit('setShowConnect', false);
                    _this5.$emit('requestConnect');
                    console.log(res, 112233);
                    _this5.$emit('agreeService');
                  }, function (error) {
                    _this5.$showTip(error, 'error');
                    _this5.$store.commit('setShowConnectCallBack', false);
                    _this5.$store.commit('setShowConnect', false);
                    _this5.$store.commit('setShowConnectIsQuery', false);
                  });
                } else {
                  if (_this5.isMobile) {
                    href = document.location.href;
                    if (type == 'MetaMask') {
                      location.href = "https://metamask.app.link/dapp/".concat(href);
                    } else if (type == 'TokenPocket') {
                      location.href = "tpdapp://open?params={\"url\": \"".concat(href, "\"}");
                    } else if (type == 'Bitget') {
                      location.href = "https://bkcode.vip?action=dapp&url=".concat(href); //vpn required
                    } else if (type == 'TrustWallet') {
                      location.href = "https://link.trustwallet.com/open_url?url=".concat(href);
                    } else if (type == 'Gate') {
                      location.href = "https://www.gate.io/zh/web3?url=".concat(href);
                    } else if (type == 'Rabby') {
                      window.open("https://rabby.io/", '_blank');
                    } else if (type == 'Nabox') {
                      scheme = 'nabox://';
                      action = 'open';
                      url = scheme + action;
                      window.location.href = url;
                      setTimeout(function () {
                        if (document.hidden) {
                          window.location.href = 'https://your-alternate-link.com';
                        }
                      }, 2000); // 2 秒后检查是否成功唤醒 Nabox 钱包
                    } else if (type == 'Fox') {
                      window.open("https://foxwallet.com/download/", '_blank');
                    }
                  } else {
                    _url = '';
                    if (type == 'MetaMask') {
                      _url = 'https://metamask.io/';
                    } else if (type == 'TokenPocket') {
                      _url = 'https://www.tokenpocket.pro/en/download/app';
                    } else if (type == 'Bitget') {
                      _url = 'https://www.bitget.com/download';
                    } else if (type == 'TrustWallet') {
                      _url = 'https://trustwallet.com/';
                    } else if (type == 'Gate') {
                      _url = "https://www.gate.io/zh/web3";
                    } else if (type == 'Rabby') {
                      _url = "https://rabby.io/";
                    } else if (type == 'Nabox') {
                      _url = "https://chrome.google.com/webstore/detail/nabox-wallet/nknhiehlklippafakaeklbeglecifhad?hl=en";
                    }
                    window.open(_url, '_blank');
                  }
                }
              }

              // Fox
              /**
               * walletConnect连接
               */
              if (type == 'WalletConnect' || type == 'Burrito') {
                walletConnect(_this5.selectdChainId).then(function (res) {
                  _this5.callBackRequest();
                  _this5.$emit('agreeService');
                }, function (error) {
                  _this5.$store.commit('setShowConnectCallBack', false);
                  _this5.$store.commit('setShowConnect', false);
                  _this5.$store.commit('setShowConnectIsQuery', false);
                });
              }
              if (type == 'OKX') {
                if (_this5.isOkxWallet) {
                  if (localStorage.getItem('walletconnect')) {
                    logOut();
                    walletConnectDisAble();
                  }
                  console.log('==okxwallet==', window);
                  okxwalletConnect(window.okxwallet || window.okexchain, 'okx', _this5.selectdChainId, 1).then(function (res) {
                    localStorage.setItem('walletType', type);
                    _this5.$store.commit('setShowConnect', false);
                    _this5.$emit('requestConnect');
                    _this5.$emit('agreeService');
                  }, function (error) {
                    _this5.$showTip(error, 'error');
                    _this5.$store.commit('setShowConnectCallBack', false);
                    _this5.$store.commit('setShowConnect', false);
                    _this5.$store.commit('setShowConnectIsQuery', false);
                  });
                } else {
                  if (_this5.isMobile) {
                    _href = document.location.href;
                    location.href = "okx://wallet/dapp/details?dappUrl=".concat(_href);
                  } else {
                    _url2 = 'https://www.okx.com/cn/web3';
                    window.open(_url2, '_blank');
                  }
                }
              }
              if (type == 'Coinbase') {
                walletConnectCoinbase(_this5.selectdChainId).then(function (res) {
                  _this5.$emit('agreeService');
                  _this5.callBackRequest();
                }, function (error) {
                  _this5.$store.commit('setShowConnectCallBack', false);
                  _this5.$store.commit('setShowConnect', false);
                  _this5.$store.commit('setShowConnectIsQuery', false);
                });
              }
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    }
  }
};